import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { History } from "@mui/icons-material";
import CustomDataGrid from '../../../../../components/ui/customDataGrid/customDataGrid.component';
import { JOB_TASKS_ENDPOINT } from '../../../../../consts';
import { useHasPermission } from '../../../../../contexts/auth';
import { JobTask } from '../../../../../types/jobs';
import { useJobTaskServiceHistoryColumns } from '../../../../service/jobs/jobTaskServiceHistoryColumns';

export const EquipmentServiceHistory = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const canViewAllJobs = useHasPermission("service.view_job");
  const canViewOwnJobs = useHasPermission("service.view_own_job");
  const canViewJobs = canViewAllJobs || canViewOwnJobs;
  const columns = useJobTaskServiceHistoryColumns();

  const handleRowClick = (jobTaskId: string, row?: JobTask) => {
    navigate(`/service/jobs/${row?.job?.id}`);
  };

  if (!canViewJobs) {
    return null;
  }

  const jobTasksUrl = id ? `${JOB_TASKS_ENDPOINT}?equipment=${id}` : JOB_TASKS_ENDPOINT;

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <CustomDataGrid
        icon={<History />}
        title={t('Service History')}
        url={jobTasksUrl}
        gridSettingsKey="EQUIPMENT_SERVICE_HISTORY"
        columns={columns}
        onRowClick={handleRowClick}
        refreshEventName="equipmentJobAdded"
      />
    </Box>
  );
};
